import React, { useEffect, useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdCheck } from 'react-icons/md';

interface CopyButtonProps {
  value?: string;
  clipboardItem?: ClipboardItem;
  buttonText?: string;
  tooltipText?: string;
  variant?: string;
  className?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  value,
  clipboardItem,
  tooltipText,
  buttonText,
  variant,
  className,
}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (value?: string | ClipboardItem) => {
    if (!value) {
      return;
    }
    const writeToClipboard =
      value instanceof ClipboardItem
        ? navigator.clipboard.write([value])
        : navigator.clipboard.writeText(value);

    writeToClipboard.then(
      () => setCopied(true),
      () => {
        console.error('Coś poszło nie tak przy kopiowaniu tekstu do schowka.');
      },
    );
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => setCopied(false), 3000);
    }
  }, [copied]);

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
          {copied
            ? 'Skopiowano do schowka. Wklej skrótem Ctrl+V.'
            : (tooltipText ?? 'Kopiuj do schowka')}
        </Tooltip>
      }
    >
      <Button
        onClick={() => copyToClipboard(value ?? clipboardItem)}
        variant={variant ?? 'link'}
        className={className ?? 'ms-1 p-0 border-0 align-baseline'}
      >
        {buttonText ??
          (copied ? (
            <MdCheck size={16} className="text-success" />
          ) : (
            <Icon.Copy size={16} className="text-muted" />
          ))}
      </Button>
    </OverlayTrigger>
  );
};

export default CopyButton;
